import { render, staticRenderFns } from "./MediaTopicPage.vue?vue&type=template&id=4c43f0bc&scoped=true&"
import script from "./MediaTopicPage.vue?vue&type=script&lang=ts&"
export * from "./MediaTopicPage.vue?vue&type=script&lang=ts&"
import style0 from "./MediaTopicPage.vue?vue&type=style&index=0&id=4c43f0bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c43f0bc",
  null
  
)

export default component.exports